/**
 * Mapeo estático de `contentSlug` (definido en `index.ts`) al string
 * Markdown correspondiente. Los MDs se importan con el flag `?raw` de
 * Vite — es lo más simple y evita cargar un runtime pesado (mdx,
 * remark plugins…) sólo para pintar texto estático.
 *
 * Añadir un capítulo:
 *   1. Crear el `.md` en `capitulos/`.
 *   2. Añadir la línea `import` con `?raw` aquí.
 *   3. Añadir la entrada al mapa `chapterMarkdown`.
 */

import conceptos from "./capitulos/1-conceptos.md?raw";
import quienEsQuien from "./capitulos/2-quien-es-quien.md?raw";
import control from "./capitulos/3-control.md?raw";
import controlCampo from "./capitulos/3-1-control-campo.md?raw";
import controlPacking from "./capitulos/3-2-control-packing.md?raw";
import controlSupermercados from "./capitulos/3-3-control-supermercados.md?raw";
import certificacionHn from "./capitulos/4-certificacion-hn.md?raw";
import certificacionHs from "./capitulos/5-certificacion-hs.md?raw";
import promocion from "./capitulos/6-promocion.md?raw";
import proveedores from "./capitulos/7-proveedores.md?raw";
import conflictoNadorcott from "./capitulos/8-conflicto-nadorcott.md?raw";

export const chapterMarkdown: Record<string, string> = {
  "1-conceptos": conceptos,
  "2-quien-es-quien": quienEsQuien,
  "3-control": control,
  "3-1-control-campo": controlCampo,
  "3-2-control-packing": controlPacking,
  "3-3-control-supermercados": controlSupermercados,
  "4-certificacion-hn": certificacionHn,
  "5-certificacion-hs": certificacionHs,
  "6-promocion": promocion,
  "7-proveedores": proveedores,
  "8-conflicto-nadorcott": conflictoNadorcott,
};
